/**
 * @file PaddlePaddle 主站页脚
 * @author wanzhongyun
 */

import React from 'react';

import footerData from './footerData';
import baiduweixinqr from '../../images/paddlepaddleQr.jpg';
import twitterqr from '../../images/twitterQr.png';
import qqqr from '../../images/qqqr.png';
import A from '../a/A';

const Footer: React.FC = React.memo(() => {
    return (
        <footer className="paddle-footer">
            <div className="paddle-footer-container">
                {footerData.map(group => (
                    <div key={group.groupName} className="paddle-footer-group">
                        <div className="paddle-footer-group-title">{group.groupName}</div>
                        <div className="paddle-footer-item-list">
                            {group.list.map(item => (
                                <div className="paddle-footer-item" key={`${group.groupName},${item.name}`}>
                                    {item.url ? (
                                        <a
                                            target={item.target}
                                            href={item.url}
                                            rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                                        >
                                            {item.name}
                                        </a>
                                    ) : (
                                        item.name
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
                <div className="paddle-footer-qr-wrap">
                    <div className="paddle-footer-qr-item">
                        <div className="paddle-footer-qr-context" style={{ backgroundImage: `url(${twitterqr})` }}>
                            <img className="paddle-footer-qr-context-img" alt="paddle weixin qr" src={twitterqr} />
                        </div>
                        <div className="paddle-footer-qr-title">Official Twitter Account</div>
                    </div>
                    <div className="paddle-footer-qr-item">
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://qm.qq.com/cgi-bin/qm/qr?k=YmkcpZyqs3lqBCe7EP0Mbss8dSoaaHFc&authKey=P9wFk7Au2kRs4OczbXGJQfUdmgDGV6KVl4sxe0ZmojWfHGOQ1%2FBGuUl6XRhPCp6L&noverify=0&group_code=793866180"
                        >
                            <div className="paddle-footer-qr-context" style={{ backgroundImage: `url(${qqqr})` }}>
                                <img className="paddle-footer-qr-context-img" alt="paddle weixin qr" src={qqqr} />
                            </div>
                            <div className="paddle-footer-qr-title">
                                <div>Official QQ Groups</div>
                            </div>
                        </a>
                    </div>
                    <div className="paddle-footer-qr-item">
                        <div className="paddle-footer-qr-context" style={{ backgroundImage: `url(${baiduweixinqr})` }}>
                            <img className="paddle-footer-qr-context-img" alt="paddle weixin qr" src={baiduweixinqr} />
                        </div>
                        <div className="paddle-footer-qr-title">Official Wechat Account</div>
                    </div>
                </div>
            </div>
            <div className="paddle-footer-bottom">
                ©Copyright 2020, PaddlePaddle developers.{' '}
                <A href="https://beian.miit.gov.cn" className="beian record-link-style" target>
                    备案号：京ICP证030173号-116
                </A>
                <a
                    className="footer-mark-number record-link-style"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000001"
                    target="_blank"
                    rel="noreferrer"
                >
                    京公网备案11000002000001号
                </a>
            </div>
        </footer>
    );
});

export default Footer;
